<template>
  <div>
    <div class="container">
      <div id="work" class="section mb-5">
        <div class="section-title">
          Work
        </div>
      </div>
      <div class="row">
        <a class="btn offset-md-10 offset-8" 
        href="https://drive.google.com/file/d/1DEVcBG85jzxuDcfv2BUtBly3uWPpfMVA/view?usp=drivesdk"
        target="_blank" rel="noopener noreferrer">
          <i class="bi bi-file-earmark-arrow-down"></i>
            Resume
        </a>
      </div>
      <div>
        <Experience class="mt-5"/>
      </div>
    </div>
  </div>
</template>

<script>
import Experience from '@/components/Experience.vue'
export default {
  name: 'Work',
  components:{
    Experience
  },
}
</script>

<style scoped>
  .btn{  
    color: white;
    background: #202022;
    border-radius: 8px;
  }
</style>

